export default __webpack_public_path__ + "static/media/menu-tile-possibilities.92d66e8d.png";